import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class ThemeService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/tag/theme-topic-sub-topic`, reqParams).then((response) => response.data);

  static get = async (type?: string, theme?: TagType[], topic?: TagType[]): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/tag/themes`, { params: { type, theme, topic } }).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteThemeOrTopicOrSubTopics = async (ids: number[], option: TagType): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/tag/theme-topic-sub-topics/${ids}`, {
      params: { type: option.type, name: option.name },
    });
    return response.status === 204;
  };
}

export default ThemeService;
